import {
  ProjectCostCodeQuantitySort,
  QueryProjectCostCodeQuantitySummaryQuery,
  QueryProjectCostCodeQuantitySummaryQueryVariables,
  SortOrder,
} from '__generated__/graphql';
import { PROJECT_COST_CODE_QUANTITY_SUMMARY_QUERY } from 'apollo/queries/project-cost-code-quantity-queries';
import useGraphQLPaging from 'hooks/graphql/useGraphQLPaging/useGraphQLPaging';
import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { NonNullArrayField } from 'types/util/NonNullArrayField';
import { Nullable } from 'types/util/Nullable';

export type TUseProgressBudgetActualsData = NonNullArrayField<
  QueryProjectCostCodeQuantitySummaryQuery['projectCostCodeQuantities']
>;

export default function useGetProgressBudgetActuals() {
  const pageAll = useGraphQLPaging();

  const getProgressBudgetActuals = useCallback(
    async (
      projectIds: string[],
      costCodeIds: string[],
      includeSubprojects: boolean,
      sort: Nullable<ProjectCostCodeQuantitySort[]> = [{ assignedOn: SortOrder.Asc }, { createdOn: SortOrder.Asc }]
    ): Promise<TUseProgressBudgetActualsData[]> => {
      const result = await pageAll<
        QueryProjectCostCodeQuantitySummaryQuery,
        QueryProjectCostCodeQuantitySummaryQueryVariables
      >(
        {
          document: PROJECT_COST_CODE_QUANTITY_SUMMARY_QUERY,
          variables: {
            filter: {
              deletedOn: { isNull: true },
              costCode: isEmpty(costCodeIds)
                ? undefined
                : {
                    id: { contains: costCodeIds },
                  },
              project: {
                idWithDescendants: includeSubprojects ? { contains: projectIds } : undefined,
                id: !includeSubprojects ? { contains: projectIds } : undefined,
              },
            },
            sort: sort ?? undefined,
          },
        },
        'projectCostCodeQuantities',
        500
      );

      return result;
    },
    [pageAll]
  );

  return getProgressBudgetActuals;
}
